// components/CompanyManagement.js

import Button from "components/ui/Button";
import useCompanyLogic from "hooks/useCompany";
import AdminNavigation from "layouts/AdminNavigation";
import CompanyModal from "./components/companyModal";
import Notification from "components/ui/Notification";
import Table from "components/ui/Table";

const CompanyManagement = () => {
    const {
        user,
        isNavCollapsed,
        companies,
        loading,
        modalState,
        notification,
        formData,
        errors,
        columns,
        setIsNavCollapsed,
        setModalState,
        closeNotification,
        showNotification,
        loadDepartments, // Renamed to loadCompanies for clarity
        handleInputChange,
        validateForm,
        handleSave,
        handleAddCompany,
        handleEditCompany,
        handleDeleteCompany,
    } = useCompanyLogic();

    return (
        <>
            <AdminNavigation
                user={user}
                isCollapsed={isNavCollapsed}
                onToggleCollapse={() => setIsNavCollapsed(!isNavCollapsed)}
            />
            <div className={`min-h-screen bg-gray-50 transition-all duration-300 ${isNavCollapsed ? 'lg:ml-16' : 'lg:ml-64'} pt-16`}>
                <div className="p-6">
                    {/* Header Component */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-slate-800">Company Management</h1>
                            <p className="text-slate-500 mt-1">Manage all company accounts</p>
                        </div>
                        <div className="mt-4 sm:mt-0">
                            <Button
                                onClick={handleAddCompany}
                                className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white"
                            >
                                Add Company
                            </Button>
                        </div>
                    </div>

                    {/* Table Component */}
                    {/* {loading ? (
                        <LoadingSpinner />
                    ) : ( */}
                        <Table
                            columns={columns}
                            data={companies}
                            emptyMessage="No companies found"
                        />
                    {/* )} */}
                </div>

                {/* Modal Component */}

                <CompanyModal
                    isOpen={modalState.isOpen}
                    onClose={() => setModalState({ isOpen: false, company: null, mode: 'add' })}
                    mode={modalState.mode}
                    formData={formData}
                    errors={errors}
                    onChange={handleInputChange}
                    onSave={handleSave}
                />

                {/* Notification Component */}
                {notification && (
                    <Notification
                        message={notification.message}
                        type={notification.type}
                        onClose={closeNotification}
                    />
                )}
            </div>
        </>
    );
};

export default CompanyManagement;